<div class="container py-4">
    <div class="row mb-3">
      <div class="col">
        <h2>Service Areas</h2>
      </div>
      <div class="col text-end">
        <button routerLink="/service-areas/create" class="btn btn-primary"  readOnlyIfNoGroupPermissionDirective [showToastWhenRendering]="false">
          <i class="bi bi-plus"></i> Add Service Area
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <ag-grid-angular
          class="ag-theme-alpine"
          [rowData]="serviceAreas"
          [columnDefs]="columnDefs"
          style="width: 100%; height: 600px;">
        </ag-grid-angular>
      </div>
    </div>
  </div>
  